<template>
  <div
    class="mt-4 px-0 py-5 flex flex-col items-center justify-center relative w-full"
  >
    <spinner :busy="loading" color="#000" class="mt-12"></spinner>

    <ul
      v-if="answers.length"
      id="scrollable-container"
      role="list"
      class="w-full h-64 bg-white divide-y divide-gray-200 rounded-md overflow-y-scroll"
    >
      <li
        v-for="(answer, idx) in answers"
        :key="idx"
        class="relative bg-white py-5 px-4 hover:bg-gray-50"
      >
        <div class="flex justify-between space-x-3 text-left">
          <div class="min-w-0 flex-1">
            <a href="#" class="block focus:outline-none">
              <span class="absolute inset-0" aria-hidden="true"></span>
              <p class="text-base text-gray-600" v-html="answer.text"></p>
            </a>
          </div>
          <time
            v-if="false"
            class="flex-shrink-0 whitespace-nowrap text-sm text-gray-500"
            >{{ convert(answer.datetime) }}</time
          >
        </div>
      </li>
    </ul>

    <p
      v-if="!answers.length && !loading && false"
      class="mt-12 text-xl sm:text-2xl font-extralight text-gray-400"
    >
      {{ translations.no_answers_yet }}
    </p>
  </div>
</template>

<script>
import Spinner from '@/Shared/Spinner';
import { map, max } from 'lodash';
import * as dayjs from 'dayjs';
import * as relativeTime from 'dayjs/plugin/relativeTime';
dayjs.extend(relativeTime);

export default {
  name: 'LiveResultsScrollableContainer',

  metaInfo() {
    return {
      title: `Live Results`,
    };
  },

  components: {
    Spinner,
  },

  props: ['session', 'translations'],

  data() {
    return {
      loading: false,
      answers: [],
      refreshIntervalId: null,
    };
  },

  mounted() {
    Echo.channel('markencode-app.session.' + this.session.id).listen(
      '.participant.answered',
      (e) => {
        this.load();
      }
    );

    this.load();

    this.refreshIntervalId = window.setInterval(() => {
      this.load();
    }, 10000);
  },

  destroyed() {
    if (this.refreshIntervalId) {
      clearInterval(this.refreshIntervalId);
      this.refreshIntervalId = null;
    }
  },

  watch: {
    answers: function () {
      this.$nextTick(function () {
        document
          .querySelector('#scrollable-container li:last-child')
          ?.scrollIntoView({ behavior: 'smooth', block: 'end' });
      });
    },
  },

  methods: {
    load() {
      if (this.loading) {
        return;
      }

      this.loading = true;

      window.axios
        .post(
          this.route('live-results.latest-answers', {
            uuid: this.session.uuid,
          }),
          {
            latest_answer_id: this.latestAnswerId,
          }
        )
        .then((response) => {
          const incomingAnswers = response.data.answers || [];

          if (!incomingAnswers.length) {
            this.loading = false;
            return;
          }

          if (!this.answers.length) {
            this.answers = incomingAnswers;
            this.loading = false;
            return;
          }

          const knownIds = new Set(map(this.answers, 'id'));
          const newAnswers = incomingAnswers.filter((answer) => !knownIds.has(answer.id));

          if (newAnswers.length) {
            this.answers = [...this.answers, ...newAnswers];
          }

          this.loading = false;
        })
        .catch((error) => {
          console.warn('live-results.latest.load failed', error?.response?.status, error?.message);
          this.loading = false;
        });
    },

    // dummy() {
    //   let id = `answer-${Math.floor(Math.random() * 20001)}`;

    //   this.answers.push({
    //     id: id,
    //     datetime: new Date,
    //     text: `${id} Doloremque dolorem maiores assumenda dolorem facilis. Velit vel
    //             in a rerum natus facere. Enim rerum eaque qui facilis. Numquam
    //             laudantium sed id dolores omnis in. Eos reiciendis deserunt
    //             maiores et accusamus quod dolor.
    //             `,
    //   });
    // },

    convert(datetime) {
      return dayjs(datetime).fromNow();
    },
  },

  computed: {
    latestAnswerId() {
      let maxId = max(map(this.answers, 'id'));

      if (maxId === undefined) {
        return null;
      }

      return maxId;
    },
  },
};
</script>
